const mapNotificationActionFromApi = (
  api: ApiNotificationActionResponse
): AppNotificationAction => {
  return {
    id: api.id,
    params: api.params,
  };
};

const mapNotificationFromApi = (
  api: ApiNotificationResponse
): AppNotification => {
  return {
    id: api.id,
    createdAt: new Date(api.created_at * 1000),
    title: api.title,
    body: api.body,
    seen: api.seen,
    read: api.read,
    actions: api.actions.map(mapNotificationActionFromApi),
    content: api.content,
    hasContent: api.has_content,
    contentAction: api.content_action,
  };
};

export {
  mapNotificationActionFromApi,
  mapNotificationFromApi,
};

export default mapNotificationFromApi;
